import React, { useState } from 'react';
import { Menu, MenuItem, ListItemIcon, ListItemText, CircularProgress } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import { useSnackbar } from '../context/SnackbarContext';
import { useAuth } from '../Auth';
import api from '../api/axiosInstance';

export default function EmailContextMenu({ anchor, user, onClose }) {
    const showSnackbar = useSnackbar();
    const { user: currentUser } = useAuth();
    const [loading, setLoading] = useState(false);

    // ONLY superusers should see the menu
    const isSuperUser = currentUser?.role === 'superuser';

    const handleSendWelcomeEmail = async () => {
        if (!user) return;
        setLoading(true);
        try {
            await api.post(`/staff/${user.id}/send-welcome`);
            showSnackbar(`Welcome email sent to ${user.email}`, 'success');
        } catch (err) {
            showSnackbar(err.response?.data?.error || 'Failed to send welcome email', 'error');
            setLoading(false);
        }
        setLoading(false);
        onClose();
    };

    if (!isSuperUser) return null;

    return (
        <Menu
            open={Boolean(anchor)}
            onClose={onClose}
            anchorReference="anchorPosition"
            anchorPosition={
                anchor ? { top: anchor.mouseY, left: anchor.mouseX } : undefined
            }
        >
            <MenuItem 
                onClick={handleSendWelcomeEmail}
                disabled={loading}
                sx={{ minWidth: 200 }}
            >
                <ListItemIcon>
                    {loading ? (
                        <CircularProgress size={20} color="inherit" />
                    ) : (
                        <EmailIcon color="primary" fontSize="small" />
                    )}
                </ListItemIcon>
                <ListItemText>Send Welcome Email</ListItemText>
            </MenuItem>
        </Menu>
    );
}
